import React from 'react';
import { withRouter } from 'react-router-dom';
import { testStore } from './TestStore';
import { TestsTable } from './TestsTable';
import { Pagination } from 'ats/components/pagination/Pagination';
import { TestEdit } from './TestEdit';
import { ListStore } from '../../../shared/stores/ListStore';
import { observer } from 'mobx-react';
import { dialogStore } from '../../layout/modals/DialogStore';
import {
	rolesAllowed,
	USER_ROLES
} from '../../../shared/security/RolesAllowed';
import SettingsSubsectionHeader from '../SettingsSubsectionHeader';
import SettingsListToolbar from '../SettingsListToolbar';
import SettingsListEmptyState from '../SettingsListEmptyState';
import { getSettingsSectionLabel } from '../settingsSections';

@rolesAllowed([USER_ROLES.ADMIN, USER_ROLES.MANAGER])
@withRouter
@observer
export class Tests extends React.Component {
	constructor(props) {
		super(props);
		this.listStore = new ListStore(testStore, {
			entityName: 'Test',
			createModalTitle: 'Create Test',
			createModal: (
				<TestEdit isNew={true} handleSuccess={() => this.listStore.search()} />
			),
			editModal: item => (
				<TestEdit
					isNew={false}
					test={item}
					handleSuccess={() => this.listStore.search()}
				/>
			)
		});
	}

	componentDidMount() {
		const resetQuery = this.preSetQuery();
		this.listStore.search(resetQuery);
	}

	preSetQuery() {
		this.listStore.store.setQuery('sort', { column: 'name', asc: true });
		this.listStore.store.setQuery(
			'pagination',
			this.listStore.store.defaultPagination
		);
		return false;
	}

	hasFilters = () => Boolean((testStore.query.text || '').trim());

	clearFilters = () => {
		testStore.setQuery('text', '');
		this.listStore.search();
	};

	render() {
		const isEmpty = !this.listStore.loading && this.listStore.data.length === 0;

		return (
			<div className="Tests container">
				<SettingsSubsectionHeader
					title={getSettingsSectionLabel('tests')}
					actions={
						<SettingsListToolbar
							field="search"
							debounce={true}
							debounceTime={400}
							searchPlaceholder="Search"
							searchValue={testStore.query.text || ''}
							onSearchChange={value => {
								testStore.setQuery('text', value);
								this.listStore.search();
							}}
							createLabel={this.listStore.modalsConfigs.createModalTitle}
							onCreate={() => this.listStore.handleCreate()}
						/>
					}
				/>
				<div className="columns">
					<div className="column is-12 table-wrapper">
						<TestsTable
							data={this.listStore.data}
							loading={this.listStore.loading}
							isEmpty={isEmpty}
							sort={this.listStore.store.query.sort}
							onSort={this.listStore.handleSort}
							onEdit={this.listStore.handleEdit}
							onDisable={item => this.listStore.handleDisable(item, true)}
							onDelete={this.handleDelete}
						/>
						{!this.listStore.loading && isEmpty ? (
							<SettingsListEmptyState
								entityPlural="tests"
								hasFilters={this.hasFilters()}
								onClearFilters={this.clearFilters}
							/>
						) : null}
					</div>
				</div>
				<div className="columns">
					<div className="column is-12 bottom-pagination">
						<Pagination
							loading={this.listStore.loading}
							pagination={testStore.query.pagination}
							totalResults={testStore.query.pagination.totalResults}
							onPaginationChange={this.listStore.handlePaginationChange}
						/>
					</div>
				</div>
			</div>
		);
	}

	handleDelete = item => {
		dialogStore.openDialog(
			{
				title: 'Delete Test',
				message: `Are you sure you want to delete ${item.name}?`,
				confirmLabel: 'Delete',
				confirmButtonClass: 'is-danger'
			},
			() => {
				this.listStore.deleteFromDialog(item);
			}
		);
	};
}
